const browserRoute = {
  HOME: "/",
  MARKET: "/market",
  BUYMARKET: "/market/buymarket",
  PORTFOLIO: "/portfolio/overview",
  LEARN: "/learn",
  PORTFOLIO_OVERVIEW: "/portfolio/overview",
  PORTFOLIO_ASSETS: "/portfolio/assets",
  PORTFOLIO_ACTIVITY: "/portfolio/assets/activity",
  PORTFOLIO_LIQUIDITY: "/portfolio/liquidity",
  INTRO_TO_LP: "/introtolp",
  NOTIFICATIONS: "/notifications",
  EARNYIELD: "/earnyield",
};
export default browserRoute;
